import Player from '@vimeo/player';

$.urlParam = function(name){
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (results == null){
        return null;
    }
    else {
        return decodeURI(results[1]) || 0;
    }
};

$(function() {
    videoPopup();
    scienceTabs();
    if($.urlParam('tab') != null) {
        $('.science-tab').removeClass('active');
        $('.science-tab').eq($.urlParam('tab')).addClass('active');
        $('.tabs-links-wrap a').removeClass('active');
        $('.tabs-links-wrap a').eq($.urlParam('tab')).addClass('active');
        if($.urlParam('tab') > 0) {
            $('.tabs-navigation').scrollLeft(200);
        }
        $('.scroll-to')[0].scrollIntoView();
    }
})

function scienceTabs() {
    var tabsNav = $('.tabs-links-wrap a');
    $('.tabs-links-wrap a').on('click', function(e) {
        e.preventDefault();
        $('.tabs-links-wrap a').removeClass('active');
        $(this).addClass('active');
        $('.science-tab').removeClass('active');
        $('.science-tab').eq($(this).index()).addClass('active');
    });

}

function videoPopup() {
    $('.video-trigger a').on('click', function(e) {
        e.preventDefault();
        $('.video-popup').addClass('visible');
        $('body, html').addClass('noscroll');
        vimeoPlayerDesktop.play();
    })
    $('.x-close, .bg-close').on('click', function(e) {
        e.preventDefault();
        $('.video-popup').removeClass('visible');
        $('body, html').removeClass('noscroll');
        vimeoPlayerDesktop.pause();
    })
}
const options = {
    loop: true,
    autoplay: false,
    controls: true,
    background: false,
    muted: false,
    playsinline: true,
  }
const vimeoPlayerDesktop = new Player("vimeo-desktop", options);
    
$('body, html').on('keydown', function(e) {
    var keyCode = e.key || e.code; 
    if (keyCode == 'Escape') {
        $('.video-popup').removeClass('visible');
        $('body, html').removeClass('noscroll');
        vimeoPlayerDesktop.pause();
    } 
 });